import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=388c688c&scoped=true"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"
import style0 from "./Listado.vue?vue&type=style&index=0&id=388c688c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c688c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388c688c')) {
      api.createRecord('388c688c', component.options)
    } else {
      api.reload('388c688c', component.options)
    }
    module.hot.accept("./Listado.vue?vue&type=template&id=388c688c&scoped=true", function () {
      api.rerender('388c688c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibos/Listado.vue"
export default component.exports